<script lang="ts">
    import {onDestroy} from 'svelte';
    import KpGenericPanel from 'shared/ui-widgets/panel/KpGenericPanel.svelte';
    import KpDropdownButton from 'shared/ui-widgets/dropdown/KpDropdownButton.svelte';
    import KpDropdownMenuLink from 'shared/ui-widgets/dropdown/KpDropdownMenuLink.svelte';
    import {KpRecordClipboardPanelPresenter} from './kp-record-clipboard-panel.presenter';
    import type {Rec} from 'typings/portaro.be.types';
    import KpCover from '../../kp-cover/KpCover.svelte';
    import KpCollectionBulkInsertButton from '../../../record-collections/kp-record-collection-bulk-insert-button/KpCollectionBulkInsertButton.svelte';
    import {fade} from 'svelte/transition';
    import {getInjector, getLocalization} from 'core/svelte-context/context';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';

    const localize = getLocalization();
    const presenter = getInjector().getByToken<KpRecordClipboardPanelPresenter>(KpRecordClipboardPanelPresenter.presenterName);

    let records: Rec[] = [];

    const recordsSubscription = presenter.getRecords$().subscribe((updatedRecordList) => records = updatedRecordList);
    onDestroy(() => recordsSubscription.unsubscribe());

    let links: Record<'ris' | 'xls' | 'csv' | 'doc', string>;
    $: links = presenter.getExportLinks(records);

    let isEmpty: boolean;
    $: isEmpty = records.length <= 0;

    let size: number;
    $: size = records.length;

    const limit = presenter.getLimit();

    function removeAll() {
        presenter.removeAll();
    }
</script>

<template>
    <div class="clipboard-container">
        {#if !isEmpty}
            <KpGenericPanel>
                <svelte:fragment slot="heading">
                    {localize(/* @kp-localization commons.Allmarked */ 'commons.Allmarked')} <span class="badge">{size}</span>
                </svelte:fragment>

                <div class="covers-list">
                    {#each records.slice(0, limit) as record (record.id)}
                        <div class="cover-container-in-mini-list" transition:fade={{duration:200}}>
                            <KpCover {record} fillTo="width"/>
                        </div>
                    {/each}
                    {#if (size > limit)}
                        <div class="and-more-message-text">&hellip;{localize(/* @kp-localization commons.aDalsi */ 'commons.aDalsi')}</div>
                    {/if}
                </div>

                <hr/>

                <button type="button"
                        class="btn btn-default btn-xs"
                        on:click={removeAll}>
                    {localize(/* @kp-localization commons.OdznacitVse */ 'commons.OdznacitVse')}
                </button>

                <!-- TODO: get export links generated by backend -->
                <KpDropdownButton buttonSize="xs" additionalButtonClasses="export-btn clipboard-export">
                    <svelte:fragment slot="button">
                        <IconedContent trailingIcon="angle-small-down">
                            Export
                        </IconedContent>
                    </svelte:fragment>
                    <svelte:fragment slot="menu">
                        <KpDropdownMenuLink href={links.ris}>{localize(/* @kp-localization export.RisButton */ 'export.RisButton')}</KpDropdownMenuLink>
                        <KpDropdownMenuLink href={links.xls}>{localize(/* @kp-localization export.XlsButton */ 'export.XlsButton')}</KpDropdownMenuLink>
                        <KpDropdownMenuLink href={links.csv}>{localize(/* @kp-localization export.CsvButton */ 'export.CsvButton')}</KpDropdownMenuLink>
                        <KpDropdownMenuLink href={links.doc}>{localize(/* @kp-localization export.DocButton */ 'export.DocButton')}</KpDropdownMenuLink>
                    </svelte:fragment>
                </KpDropdownButton>

                <KpCollectionBulkInsertButton {records}/> <!-- TODO: in future change to slot and add additional buttons from outside context-->
            </KpGenericPanel>
        {/if}
    </div>

</template>

<style lang="less">
  .covers-list {
    display: flex;
  }

  .cover-container-in-mini-list {
    width: 23px;
    margin-right: 2px;
  }

  .and-more-message-text {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
</style>